import "../scss/main.scss";

jQuery(function ($) {
    $(".toggle-nav").click(function (e) {
        $(".navbar .mobile-menu-container").css("transform", "translateX(0)");
        $(".overlay").fadeIn();
        e.preventDefault();
    });

    $(".overlay").click(function (e) {
        $(".navbar .mobile-menu-container").css("transform", "translateX(-100%)");
        $(".overlay").fadeOut();
        $("#search").fadeOut();
        e.preventDefault();
    });

    $("header .container .cart-container a.search").click(function (e) {
        e.preventDefault();
        $(".overlay").fadeIn();
        $("#search").fadeIn();
    });

    $(".slides").slick({
        prevArrow:
            '<img class="prev" src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/chevron.svg">',
        nextArrow:
            '<img class="next" src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/chevron.svg">',
        dots: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                },
            },
        ],
    });

    $(".product-section ul.products").slick({
        slidesToShow: 3,
        prevArrow:
            '<img class="prev" src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/chevron.svg">',
        nextArrow:
            '<img class="next" src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/chevron.svg">',
        autoplay: true,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(document).on("change", "#checkout_check_all", function () {
        const input = $(this);
        const checkboxes = $(".form-row.place-order").find(":checkbox");
        if (input.is(":checked")) {
            checkboxes.each(function () {
                $(this).prop("checked", true);
            });
        } else {
            checkboxes.each(function () {
                $(this).prop("checked", false);
            });
        }
    });

    $('ul.products li.product .add_to_cart_button[data-product_id="8718"]').removeClass("ajax_add_to_cart");

    var BaPopup = {
        init: function () {
            this.closePopupHandler();
            this.openPopupHandler();
        },

        closePopupHandler: function () {
            $(document).on("click", ".ba-popup__close", (e) => {
                e.preventDefault();
                $(".ba-popup").removeClass("visible");
            });
        },

        openPopupHandler: function () {
            const _this = this;
            $(document).on("click", "[data-ba_popup]", function (e) {
                e.preventDefault();
                let handle = $(this).data("ba_popup");
                _this.openPopup(handle);
            });
        },

        openPopup: function (handle) {
            $(handle).addClass("visible");
        },
    };

    BaPopup.init();

    var Theme = {
        init: function () {
            this.defineCompanyFieldsVisibility();
            this.invoiceFieldChanger();
            this.checkoutFields();
        },

        invoiceFieldChanger: function () {
            $(document).on("change", '[name="billing_invoice"], [name="billing_faktura"]', () => {
                this.defineCompanyFieldsVisibility();
            });
        },

        defineCompanyFieldsVisibility: function () {
            const invoiceField = $('[name="billing_invoice"]:checked');
            const wfirmaInvoiceField = $('[name="billing_faktura"]:checked');
            if (invoiceField.length > 0 || wfirmaInvoiceField.length > 0) {
                this.showCompanyFields();
            } else {
                this.hideCompanyFields();
            }
        },

        showCompanyFields: function () {
            $("#billing_company_field, #billing_nip_field").show();
        },

        hideCompanyFields: function () {
            $("#billing_company_field, #billing_nip_field").hide();
            $("#billing_nip, #billing_company").val("");
        },

        checkoutFields: function () {
            const formRows = document.querySelectorAll(
                ".woocommerce-billing-fields .form-row, .woocommerce-shipping-fields .form-row"
            );

            formRows.forEach((row) => {
                const input = row.querySelector("input:not(#billing_gift_send_date), select, textarea");
                if (input) {
                    if (input.value) {
                        row.classList.add("has-content");
                    }

                    input.addEventListener("input", () => {
                        if (input.value) {
                            row.classList.add("has-content");
                        } else {
                            row.classList.remove("has-content");
                        }
                    });

                    input.addEventListener("focus", () => {
                        row.classList.add("has-focus");
                    });

                    input.addEventListener("blur", () => {
                        row.classList.remove("has-focus");
                        if (!input.value) {
                            row.classList.remove("has-content");
                        }
                    });
                }
            });

            $('.easy-checkout button.ec-payment-button[data-ec_payment_method="stripe"]').append(
                '<img src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/stripe.svg" alt="stripe">'
            );
            $('.easy-checkout button.ec-payment-button[data-ec_payment_method="ppcp-gateway"]').append(
                '<img src="https://bibliaaudio.pl/sklep/wp-content/themes/bibliaaudio/img/paypal.svg" alt="paypal">'
            );
        },
    };

    Theme.init();
});
